import { MAX_STARS } from "@versedrill/core";

export interface ShareInput {
  number: number;
  /** The redacted verse text, so the share doesn't spoil names. */
  text: string;
  /** The Bible version the words are quoted from (e.g. "NIV"), shown after the quote. */
  version?: string;
  stars: number;
  score: number;
  streak: number;
  url: string;
}

/** Plain-text result card. Never contains the answer: only the (redacted) verse, stars and streak. */
export function shareText(i: ShareInput): string {
  const stars = "⭐".repeat(i.stars) + "☆".repeat(MAX_STARS - i.stars);
  return `#PassTheVerse ${i.number} Where in the Bible?\n“${i.text}”${i.version ? ` (${i.version})` : ""}\n\nMy results: ${stars} (${i.score} points)\n\n🔥 streak: ${i.streak}\n\n${i.url}`;
}

/** Native share sheet when available, else the clipboard. Resolves to what happened. */
export async function shareResult(text: string): Promise<"shared" | "copied" | "cancelled" | "failed"> {
  if (typeof navigator !== "undefined" && navigator.share) {
    try {
      await navigator.share({ title: "Pass the Verse", text });
      return "shared";
    } catch (e) {
      if (e instanceof DOMException && e.name === "AbortError") return "cancelled";
    }
  }
  try {
    await navigator.clipboard.writeText(text);
    return "copied";
  } catch {
    return "failed";
  }
}

/** The message that goes with a sent-verse link. Deliberately spoiler-free: it never names the passage. */
export function inviteMessage(name: string, url: string): string {
  return `${name.trim() ? `${name.trim()} picked` : "I picked"} a verse for you. Can you find where it lives in the Bible? ${url}`;
}
